/* ══════════════════════════════════════════════════════════════════════
   CORRECTIFS — Claude, 2026-09-15. Voir `kelvin-correctifs.css`.
   Vanilla, sans dépendance, conforme à « pas de framework » de CLAUDE.md.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var racine = document.documentElement;

  /* ── 1. Marquer le défilement en cours ──────────────────────────────
     Une classe posée au premier cran, retirée après 140 ms sans
     mouvement. 140 ms : assez long pour couvrir l'inertie d'un trackpad
     entre deux crans, assez court pour que le survol volontaire
     reprenne dès que la main s'arrête. */
  var minuteur = null;
  function defile() {
    if (!minuteur) racine.classList.add('k-defile');
    window.clearTimeout(minuteur);
    minuteur = window.setTimeout(function () {
      racine.classList.remove('k-defile');
      minuteur = null;
    }, 140);
  }
  window.addEventListener('scroll', defile, { passive: true });
  window.addEventListener('wheel', defile, { passive: true });
  window.addEventListener('touchmove', defile, { passive: true });

  /* ── 2. Décaler l'en-tête sous le bandeau d'annonce ─────────────────
     On lit la hauteur RÉELLE du bandeau (48 px bureau, 69 px mobile) et
     on décale l'en-tête fixe de ce qui en reste visible. Le bandeau
     défile normalement ; l'en-tête le suit puis se colle en haut. */
  var bandeau = document.querySelector(
    '.bandeau, [class*="bandeau"], .la-annonce, [class*="annonce"]'
  );
  function placerEntete() {
    if (!bandeau) return;
    var b = bandeau.getBoundingClientRect();
    /* `b.bottom` est la part du bandeau encore au-dessus du pli.
       Bornée à [0, hauteur] : négative une fois le bandeau dépassé. */
    var reste = Math.max(0, Math.min(b.height, b.bottom));
    racine.style.setProperty('--k-decalage-entete', reste.toFixed(1) + 'px');
  }
  window.addEventListener('scroll', placerEntete, { passive: true });
  window.addEventListener('resize', placerEntete);
  placerEntete();

  /* ── 3. Adoucir le « grow on scroll » ───────────────────────────────
     Mesuré : scale 0,9403 → 1, soit 583→620 px de large et 23 px de
     déplacement. L'effet est voulu, son amplitude était trop forte.
     Ramenée à 0,03 (0,97 → 1). On réécrit l'attribut plutôt que le
     moteur : `kelvin-motion-la.js` relit `data-grow` à chaque mesure,
     et il re-mesure au `resize` — d'où l'événement émis ensuite. */
  var PLAFOND = 0.03;
  function adoucir() {
    var n = 0;
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-grow]'),
      function (el) {
        var v = parseFloat(el.getAttribute('data-grow'));
        if (isNaN(v)) v = 0.08;                 /* défaut du moteur */
        if (v > PLAFOND) { el.setAttribute('data-grow', String(PLAFOND)); n++; }
      }
    );
    if (n) window.dispatchEvent(new Event('resize'));
    return n;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', adoucir);
  } else {
    adoucir();
  }
  /* Le moteur peut mesurer après le chargement des polices : on repasse. */
  window.addEventListener('load', adoucir);
})();
